import { render } from "./ModulTestimonials.vue?vue&type=template&id=1f76fb80"
import script from "./ModulTestimonials.vue?vue&type=script&lang=js"
export * from "./ModulTestimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__